module.exports = __webpack_public_path__ + "img/phase2-gallery-02.44b21884.png";